import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFetch, setShowModal } from "../../store/slices/listaNegraSlice.ts";
import { RootState } from "../../store";
import { deleteRecord } from "../../services/blacklist.service.ts";
import { notification } from "../../utils/Notifications.tsx";

const DeleteRecordBlackList = ({ closeFn }: { closeFn: () => void }) => {
  const { currentRecord, fetch } = useSelector(
    (state: RootState) => state.listaNegra
  );
  const dispatch = useDispatch();

  const removeRecord = async () => {
    try {
      const response = await deleteRecord(currentRecord.id);
      dispatch(setFetch(!fetch));
      closeFn();
      notification("", "Registro eliminado", "info");
    } catch (error) {
      console.log(error);
      notification("Error", error.message, "danger");
    }
  };

  return (
    <React.Fragment>
      <p className="fs-15px">
        ¿Estás seguro de que deseas eliminar a {currentRecord.curp}?
      </p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={() => removeRecord()}>
          Eliminar
        </button>
      </div>
    </React.Fragment>
  );
};

export default DeleteRecordBlackList;
